import { z } from 'zod';

export const ClassificationDetectionMatch = z.object({
    coefficient: z.object({
        min: z.number(),
        max: z.number(),
        mean: z.number(),
    }),
    additionalDetectionsCount: z.number(),
    missingDetectionsCount: z.number(),
});
export type ClassificationDetectionMatch = z.infer<typeof ClassificationDetectionMatch>;
